import React, { useContext, useState } from 'react';
import { Control, Controller, UseFormMethods } from 'react-hook-form';
import { Context } from 'vm';
import {
	FormUpdater,
	RadioGroup,
	TextBox,
	TextBoxPhone,
} from '../../../../hoc/components/inputs';
import { FormConstants } from '../../../../hoc/constants/form.constants';
import { enrollmentContext } from '../../../../hoc/context/enrollment/enrollment-context';
import context from '../../../../hoc/context/product/context';
import { RichText } from '../../../../hoc/components';
import { sendGaFocusEvent } from '../../patient/enrollment-ga-events';

export const Communication: React.FC<{
	hookProps: {
		errors: UseFormMethods['errors'];
		register: UseFormMethods['register'];
	};
	control: Control;
	setValue: UseFormMethods['setValue'];
	clearErrors: UseFormMethods['clearErrors'];
}> = ({ control, hookProps, setValue, clearErrors }) => {
	const ctxt: Context = useContext(context);
	const enrollmentCtxt = useContext(enrollmentContext);
	const [forceRender, setForceRender] = useState<boolean>(true);
	const emailMaxLength = 64;

	return (
		<>
			{/* Email input*/}
			<div className="mb-5">
				<TextBox
					label={ctxt.json.getField('email').label}
					name={'email'}
					maxLength={emailMaxLength}
					className="mb-6"
					{...hookProps}
					setValue={setValue}
					onChange={() => clearErrors('email')}
				/>
				<FormUpdater control={control} controlName={'email'} />
				{ctxt.json.pages.userProfile.noEmailHeader &&
					ctxt.json.pages.userProfile.noEmailDescription && (
						<div className="mt-6 flex flex-col">
							<p className="text-brand font-bold">
								<RichText html={ctxt.json.pages.userProfile.noEmailHeader} />
							</p>
							<p className="text-font">
								<RichText
									html={ctxt.json.pages.userProfile.noEmailDescription}
								/>
							</p>
						</div>
					)}
			</div>
			{/* Phone input*/}
			<div className="grid grid-cols-1 gap-x-4 gap-y-5 md:grid-cols-3">
				<div className="col-span-1">
					<Controller
						control={control}
						name={'phone'}
						render={({ onBlur, onChange, value }) => (
							<TextBoxPhone
								name={'phone'}
								setValue={setValue}
								value={value}
								clearErrors={clearErrors}
								onChange={onChange}
								hookProps={hookProps}
								onBlur={onBlur}
								onFocus={() => {
									sendGaFocusEvent('phone');
								}}
							/>
						)}
					/>
					<FormUpdater control={control} controlName={'phone'} />
				</div>
				<div className="col-span-1">
					<Controller
						control={control}
						name={'phoneusage'}
						render={({ onChange, value }) => (
							<RadioGroup
								name={'phoneusage'}
								help=""
								label={ctxt.json.getField('phoneusage').label}
								ariaLabel={ctxt.json.getField('phoneusage').label}
								className="flex flex-col lg:flex-row gap-x-4 gap-y-5 mt-2"
								options={ctxt.json.getField('phoneusage')?.options}
								defaultValue={enrollmentCtxt.getFormField('phoneusage')?.value}
								value={value}
								onChange={(data: React.ChangeEvent<HTMLInputElement>) => {
									onChange(data);
									enrollmentCtxt.updateFormField({
										id: 'mobile',
										answer: undefined,
									});
									setForceRender(!forceRender);
									clearErrors('phoneusage');
								}}
								onFocus={() => {
									//TBD: use analytics props instead and remove onFocus
									sendGaFocusEvent('phoneusage');
								}}
								{...hookProps}
							/>
						)}
					/>
					<FormUpdater control={control} controlName={'phoneusage'} />
				</div>
				<div className="col-span-1">
					{enrollmentCtxt.getFormField('phoneusage')?.value ===
						FormConstants.phoneUsageHome && (
						<>
							<Controller
								control={control}
								name={'mobile'}
								render={({ onBlur, onChange, value }) => (
									<TextBoxPhone
										name={'mobile'}
										setValue={setValue}
										value={value}
										clearErrors={clearErrors}
										onChange={onChange}
										hookProps={hookProps}
										onBlur={onBlur}
										onFocus={() => {
											sendGaFocusEvent('mobile');
										}}
									/>
								)}
							/>
							{!hookProps.errors?.mobile?.type && (
								<p className="mt-1 text-font text-xs md:text-base">
									<RichText
										html={ctxt.json.pages.userProfile.servicefieldMobileContent}
									/>
								</p>
							)}
							<FormUpdater control={control} controlName={'mobile'} />
						</>
					)}
				</div>
			</div>
		</>
	);
};

export default Communication;
